import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { localStorageKeys } from '../../../utils';
import { initializeLevelParam } from '../LevelFilter';
import { initializeBeginFilterParams } from './useBeginFilterParams';

let hasInitialized = false;

// Exported for testing - allows tests to reset the initialization state
export function resetInitialization() {
  hasInitialized = false;
}

export function useInitialFehlerPageParams() {
  const [, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (hasInitialized) {
      return;
    }

    setSearchParams((prev) => {
      const storedSearchParams =
        prev.size > 0
          ? prev
          : new URLSearchParams(localStorage.getItem(localStorageKeys.FEHLER_PAGE_SEARCH_PARAMS) ?? '');

      initializeBeginFilterParams(storedSearchParams);
      initializeLevelParam(storedSearchParams);

      return storedSearchParams;
    });

    hasInitialized = true;
  }, [setSearchParams]);
}
